var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('organisations',{key:_vm.key,attrs:{"organisations":_vm.organisations,"organisationtypes":_vm.organisationTypes},on:{"organisationChange":function($event){return _vm.getOrganisations()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }